import { render, staticRenderFns } from "./QuickTipsReviewRetireMergeConfirmation.vue?vue&type=template&id=51e8babe&scoped=true&"
import script from "./QuickTipsReviewRetireMergeConfirmation.vue?vue&type=script&lang=js&"
export * from "./QuickTipsReviewRetireMergeConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8babe",
  null
  
)

export default component.exports